import { isDefined } from '@sgme/fp';
import { ProductNodeBuilderProps } from 'components/common-form/builder/form/node/ProductNodeBuilder.model';
import { connect } from 'react-redux';
import { AppState } from 'state/state.model';
import { getUnderlyingsDatesByTabId } from 'state/underlyingsDates/underlyingsDates.selectors';
import {
  UnderlyingsDatesBlackoutDatesState,
  UnderlyingsDatesMapStateValue,
  UnderlyingsDatesSpecificDatesState,
} from 'state/underlyingsDates/underlyingsDatesState.model';
import { isSuccess, LoadableContent } from 'utils/status';

interface StateProps {
  specificDates?: string[];
  blackoutDates?: string[];
}

export type SpecificOfBlackoutDateProps = ProductNodeBuilderProps & StateProps;

const mapStateToProps = (state: AppState, { tabId }: ProductNodeBuilderProps): StateProps => {
  const underlyingDates = getUnderlyingsDatesByTabId(state, tabId);
  return buildFinalValuationDates(underlyingDates);
};
export const connectSpecificOrBlackoutDate = connect(mapStateToProps);

export function buildFinalValuationDates(
  underlyingDatesValue: LoadableContent<UnderlyingsDatesMapStateValue> | undefined,
): StateProps {
  if (!isDefined(underlyingDatesValue) || !isSuccess(underlyingDatesValue)) {
    return {};
  }
  const { specificDates } = underlyingDatesValue.content as UnderlyingsDatesSpecificDatesState;
  const { blackoutDates } = underlyingDatesValue.content as UnderlyingsDatesBlackoutDatesState;
  if (specificDates !== undefined && blackoutDates === undefined) {
    return { specificDates };
  }
  if (specificDates === undefined && blackoutDates !== undefined) {
    return { blackoutDates };
  }
  return {};
}
